import classNames from 'classnames'
import type { ContentTeaserProps } from './types'

export const ContentTeaser = ({
  children,
  className,
  ...props
}: ContentTeaserProps) => {
  return (
    <article className={classNames('content-teaser', className)} {...props}>
      {children}
    </article>
  )
}
